import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrowserTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 236,
	height: 145,
	viewBox: "0 0 236 145",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.9717 2.26758L40.4688 17.7647M40.4688 2.26758L24.9717 17.7647",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219.283 98.8057L227.419 106.942M227.419 98.8057L219.283 106.942",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 216.699,
			cy: 124.375,
			rx: 3.09943,
			ry: 2.32457,
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 25.9717,
			y: 33.8408,
			width: 175.387,
			height: 109.893,
			rx: 4,
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 32.8867,
			y: 40.6191,
			width: 2.50613,
			height: 2.17554,
			rx: 1.08777,
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.3369,
			y: 40.6191,
			width: 2.50613,
			height: 2.17554,
			rx: 1.08777,
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 49.7871,
			y: 40.6191,
			width: 2.50613,
			height: 2.17554,
			rx: 1.08777,
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 24.9717,
			y1: 49.5293,
			x2: 202.359,
			y2: 49.5293,
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .445312,
			y: 88.7852,
			width: 92.7128,
			height: 33.2815,
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16504 99.8818L21.0513 111.768M21.0513 99.8818L9.16504 111.768",
			stroke: "white",
			strokeWidth: 3,
			strokeLinecap: "round"
		})
	]
});
export default SvgBrowserTab;
